<template>
  <div>
    <div class="mgt-20px">
      <info-ot-update :ordreTravail="ordreTravail"
      @otAffichageDateChange = "otAffichageDateChange">
      </info-ot-update>
    </div>
    <div class="mgt-20px">
      <annonceur :ordreTravail="ordreTravail" @ajouterFace="ajouterFace"
        :displayAjouterFaceButton="true"></annonceur>
    </div>
    <div class="mgt-20px mgb-20px">
      <selecteur-action
              @handleAction="handleActions"
              :options="actions"
              :placeholder='$t("general.placeHolder.groupedAction")'
              :elementsSelectionnes="getAllSelected().length > 0"
              titleButton="general.button.apply">
      </selecteur-action>
    </div>
    <div class="mgt-20px">
      <table class="VueTables__table table is-bordered is-fullwidth">
        <thead>
          <th>
          <a @click="selectAll()">
            <b-icon :icon="iconSelectTotal"></b-icon>
          </a>
        </th>
        <th>{{ $t('detailOrdreTravailAffichage.tab.ordre') }}</th>
        <th>{{ $t('detailOrdreTravailAffichage.tab.panneaux') }}</th>
        <th></th>
        <th>{{ $t('detailOrdreTravailAffichage.tab.faces') }}</th>
        <th>{{ $t('detailOrdreTravailAffichage.tab.pose')}}</th>
        <th>{{ $t('detailOrdreTravailAffichage.tab.commentaire') }}</th>
        <th>{{ $t('detailOrdreTravailAffichage.tab.restriction') }}</th>
        <th>{{ $t('detailOrdreTravailAffichage.tab.affichagePrecedent') }}</th>
        <th>{{ $t('detailOrdreTravailAffichage.tab.affichageEffectue') }}</th>
        <th>{{ $t('detailOrdreTravailAffichage.tab.laisserEnPlace') }}</th>
        <th>{{ $t('detailOrdreTravailAffichage.tab.grattage') }}</th>
        <th></th>
        </thead>
        <tr v-for="(face, index) in facesOtSort" :key="index"
          :class="face.pairImpair">
          <td class="colonneSelected">
            <b-checkbox
              :value="face.selected"
              @input="selectFace(face)"
            >
            </b-checkbox>
          </td>
          <td>
            <b-field
               class="max-width-60"
               custom-class="is-marginless ellipsis has-text-link is-size-7">
               <b-input type="number"
                :value="face.ordre"
                @input="setOrdreToFace($event, face)"/>
            </b-field>
          </td>
          <td :class="{'has-background-light-orange': face.ajoutApresCreation}">
            <div class="columns">
              <div class="column">
                <p class="has-text-link is-size-5 has-text-weight-bold">
                  {{ $t('detailOrdreTravailAffichage.tab.panneau',
                  { code : face.materielCode }) }}
                </p>
                <p class="has-text-default">
                  {{ adressFullStringGetter(face.dispositifAdresse) }}
                </p>
                <div class="columns mgt-5px">
                  <div class="column is-4">
                    <b-field :label="$t('detailOrdreTravailAffichage.tab.format')"
                            custom-class="has-text-weight-bold is-marginless">
                      <p class="has-text-default">{{ face.format }}</p>
                    </b-field>
                  </div>
                  <div class="column is-4">
                    <b-field :label="$t('detailOrdreTravailAffichage.tab.nbFaces')"
                            custom-class="has-text-weight-bold is-marginless">
                      <p class="has-text-default">
                        {{ face.materielNbFace }}
                      </p>
                    </b-field>
                  </div>
                  <div class="column is-4">
                    <b-field :label="$t('detailOrdreTravailAffichage.tab.disposition')"
                            custom-class="has-text-weight-bold is-marginless">
                      <p class="has-text-default">
                        {{ face.materielDisposition }}
                      </p>
                    </b-field>
                  </div>
                </div>
              </div>
            </div>
          </td>
          <td :class="getBackgroundColor(face)"
              class="vertical-alignment has-text-centered">
            <b-icon :icon="getIcon(face)"
                    type="is-link" size="is-medium"></b-icon>
          </td>
          <td :class="{'has-background-light-orange': face.ajoutApresCreation}">
            <span>{{ $t('detailOrdreTravailAffichage.tab.faceNb') }}</span>
            <span class="has-text-weight-bold">{{ face.produitReference }}</span>
          </td>
          <td> {{ face.pose}} </td>
          <td> {{ face.instructionPose }} </td>
          <td> {{ face.restrictionsAffichage }} </td>
          <td> {{ face.affichagePrecedent }} </td>
          <td class="vertical-alignment is-cursor-pointer"
              @click="addCommentaire(face, constantes.AFFICHAGE)">
            <div class="columns">
              <div class="column is-2 mg-auto has-text-centered">
                <b-icon :icon="face.affichage ? 'check-circle' : 'close-circle'"
                        size="mdi-24px"
                        :type="face.affichage ? 'is-success' : 'is-danger'"></b-icon>
              </div>
              <div class="column is-10 mg-auto">
                <a class="lien" v-if="!face.commentaireAffichage">
                  {{ $t('detailOrdreTravailAffichage.tab.addCommentaire') }}
                </a>
                <p v-else-if="face.commentaireAffichage" class="lien">
                  {{ face.commentaireAffichage}}
                </p>
              </div>
            </div>
          </td>
          <td class="vertical-alignment is-cursor-pointer"
              @click="addCommentaire(face, constantes.LAISSERENPLACE)">
            <div class="columns">
              <div class="column is-2 mg-auto has-text-centered">
                <b-icon :icon="face.laisserEnPlace ? 'check-circle' : 'close-circle'"
                        size="mdi-24px"
                        :type="face.laisserEnPlace ? 'is-success' : 'is-danger'"></b-icon>
              </div>
              <div class="column is-10 mg-auto">
                <a class="lien" v-if="!face.commentaireLaisserEnPlace">
                  {{ $t('detailOrdreTravailAffichage.tab.addCommentaire') }}
                </a>
                <p v-else-if="face.commentaireLaisserEnPlace" class="lien">
                  {{ face.commentaireLaisserEnPlace}}
                </p>
              </div>
            </div>
          </td>
          <td class="vertical-alignment is-cursor-pointer"
              @click="changeStateGrattage(face)">
            <div class="has-text-centered" v-if="face.grattage">
              <b-icon icon="check-circle" size="mdi-24px"
                      type="is-success"></b-icon>
            </div>
          </td>
          <td class="vertical-alignment">
            <a class="button is-primary is-fullwidth"
              @click="remplacer(face)">
              <span>
                {{ $t('modificationOrdreTravailAffichage.remplacementFaceOT.remplacer')}}
              </span>
            </a>
          </td>
          <td class="vertical-alignment colonneSelected"
            @click="lancerPopupSupp(face)">
            <b-icon icon="delete-forever" type="is-danger">
            </b-icon>
          </td>
        </tr>
      </table>
    </div>
    <b-modal v-model="popUpCommentaire"
             has-modal-card
             class="modal">
      <pop-up-commentaire :face="faceSelect" :type="typeCommentaire">
      </pop-up-commentaire>
    </b-modal>
    <b-modal v-model="affichagePopUpAJoutFace"
             has-modal-card
             class="modal">
      <pop-up-ajout-face :ordreTravail="ordreTravail">
      </pop-up-ajout-face>
    </b-modal>
    <b-modal v-model="showPopupSuppFace" v-if="faceASupprimer != null" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="this.$t('modificationOrdreTravailAffichage.popUpSuppression.title',
        {face: faceASupprimer.produitReference })"
        :cancel="this.$t('general.non')"
        :validate="this.$t('general.oui')"
        @no="showPopupSuppFace = false"
        @yes="suppressionFace"/>
    </b-modal>
    <b-modal has-modal-card
      v-model="affichagePopupActionOnFace" class="modal">
      <popupAffichageGrattage
        :actionOnFace="action"
         @preapreAffichageFaceUpdate="$emit('preapreAffichageFaceUpdate', $event)"
        :seletedFaces="getAllSelected()"
      />
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import infoOtUpdate from '@/components/logistique/ordreTravail/affichage/InfoOtUpdate';
import popUpPrevention from '@/components/general/popUpPrevention';
import annonceur from '@/components/logistique/ordreTravail/affichage/annonceur';
import popUpCommentaire from '@/components/logistique/ordreTravail/affichage/p_commentaire';
import popUpAjoutFace from '@/components/logistique/ordreTravail/affichage/p_ajoutFaceAnnonceur';
import { ORDRE_TRAVAIL } from '@/configuration/logistique/permissionsLogistiqueConf';
import {
  LIST_ICON_AND_COLOR,
  INDEX_REGROUPEMENT_MANUEL,
  ACTION_MASS_AFFICHER_NE_PAS_AFFICHER,
  ACTION_MASS_GRATTER_NE_PAS_GRATTER,
  AFFICHAGE,
  LAISSERENPLACE,
  ACTION_MASS_LAISSER_NE_PAS_LAISSER,
} from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { getIcon, getBackgroundColor } from '@/services/logistique/ordreTravail/affichage/getIconAndBackgroundColorTabOt';
import * as types from '@/store/modules/logistique/ordreTravailAffichage-mutation-type';
import { sortBy } from 'lodash';
import selecteurAction from '@/components/general/selecteurAction';
import popupAffichageGrattage from '@/components/logistique/ordreTravail/affichage/p_affichageGrattage';

const Ot = createNamespacedHelpers('ordreTravailAff');

export default {
  name: 'ordreTravailUpdate',
  data() {
    return {
      permOrdreTravail: ORDRE_TRAVAIL,
      popUpCommentaire: false,
      affichagePopUpAJoutFace: false,
      faceSelect: null,
      faceASupprimer: null,
      showPopupSuppFace: false,
      typeCommentaire: '',
      constantes: {
        LIST_ICON_AND_COLOR: LIST_ICON_AND_COLOR,
        ACTION_MASS_AFFICHER_NE_PAS_AFFICHER,
        ACTION_MASS_GRATTER_NE_PAS_GRATTER,
        ACTION_MASS_LAISSER_NE_PAS_LAISSER,
        AFFICHAGE,
        LAISSERENPLACE,
      },
      affichagePopupActionOnFace: false,
      action: null,
    };
  },
  props: {
    ordreTravail: {
      required: true,
      type: Object,
    },
    ordreByFace: {
      type: Array,
      required: true,
    },
  },
  components: {
    infoOtUpdate,
    annonceur,
    popUpCommentaire,
    popUpAjoutFace,
    popUpPrevention,
    selecteurAction,
    popupAffichageGrattage,
  },
  computed: {
    facesOtSort() {
      return sortBy(this.ordreTravail.faces, [
        (face) => (face.ordre === null ? -Infinity : face.ordre),
        'materielCode',
        'produitReference',
      ]);
    },
    allItemsSelected() {
      return this.getAllSelected().length === this.facesOtSort.length
        && this.facesOtSort.length > 0;
    },
    iconSelectTotal() {
      if (this.allItemsSelected) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    actions() {
      return [
        {
          action: this.constantes.ACTION_MASS_AFFICHER_NE_PAS_AFFICHER,
          translation: 'modificationOrdreTravailAffichage.actions.affichage',
        },
        {
          action: this.constantes.ACTION_MASS_LAISSER_NE_PAS_LAISSER,
          translation: 'modificationOrdreTravailAffichage.actions.laisserEnPlace',
        },
        {
          action: this.constantes.ACTION_MASS_GRATTER_NE_PAS_GRATTER,
          translation: 'modificationOrdreTravailAffichage.actions.grattage',
        },
      ];
    },
  },
  methods: {
    ...Ot.mapMutations({
      setOtCourant: types.SET_OT_COURANT,
      setFaceARemplacer: types.SET_FACE_A_REMPLACER,
    }),
    setOrdreToFace(value, face) {
      this.ordreByFace.forEach(ordreByFace => {
        if (ordreByFace.faceId === face.faceId) {
          ordreByFace.value = +value;
        }
      });
    },
    otAffichageDateChange(dateDepart) {
      this.$emit('otAffichageDateChange', dateDepart);
    },
    changeStateGrattage(face) {
      face.grattage = !face.grattage;
    },
    getIcon(face) {
      return getIcon(face);
    },
    getBackgroundColor(face) {
      return getBackgroundColor(face);
    },
    addCommentaire(face, type) {
      const index = this.ordreTravail.faces.indexOf(face);
      this.faceSelect = this.ordreTravail.faces[index];
      this.typeCommentaire = type;
      this.popUpCommentaire = true;
    },
    adressFullStringGetter(adresse) {
      return adressFullStringGetter(adresse, false);
    },
    remplacer(face) {
      if (!face) return;
      this.setOtCourant(this.ordreTravail);
      this.setFaceARemplacer(face);
      this.$router.push({ name: 'l.logistique.ordre_travail-affichage-remplacement' });
    },
    ajouterFace() {
      this.affichagePopUpAJoutFace = true;
    },
    lancerPopupSupp(face) {
      this.faceASupprimer = face;
      this.showPopupSuppFace = true;
    },
    suppressionFace() {
      this.showPopupSuppFace = true;
      if (this.faceASupprimer == null) return;
      const annonceurs = this.ordreTravail.annonceurs.filter(a => {
        if (this.faceASupprimer.indexRegroupement === INDEX_REGROUPEMENT_MANUEL
            && this.faceASupprimer.affectationLogistiqueCommandeId !== null) {
          return a.devisCommandeId === this.faceASupprimer.affectationLogistiqueCommandeId;
        }
        return a.indexRegroupement === this.faceASupprimer.indexRegroupement;
      });
      if (annonceurs.length > 0) {
        annonceurs[0].nbFaces -= 1;
      }
      const indexASupp = this.ordreTravail.faces.indexOf(this.faceASupprimer);
      if (indexASupp !== -1) {
        this.ordreTravail.faces.splice(indexASupp, 1);
      }
      this.faceASupprimer = null;
    },
    getAllSelected() {
      return this.facesOtSort.filter((el) => el.selected);
    },
    initSelection() {
      this.ordreTravail.faces = this.ordreTravail.faces.map(face => {
        face.selected = false;
        return face;
      });
    },
    selectFace(face) {
      const state = !face.selected;
      this.ordreTravail.faces = this.ordreTravail.faces.map(item => {
        if (item.faceId === face.faceId) {
          item.selected = state;
        }
        return item;
      });
      this.setOtCourant(this.ordreTravail);
    },
    selectAll() {
      const state = !this.allItemsSelected;
      this.ordreTravail.faces = this.ordreTravail.faces.map(item => {
        item.selected = state;
        return item;
      });
      this.setOtCourant(this.ordreTravail);
    },
    handleActions(action) {
      switch (action) {
        case this.constantes.ACTION_MASS_AFFICHER_NE_PAS_AFFICHER:
          this.affichagePopupActionOnFace = true;
          this.action = this.constantes.ACTION_MASS_AFFICHER_NE_PAS_AFFICHER;
          break;
        case this.constantes.ACTION_MASS_LAISSER_NE_PAS_LAISSER:
          this.affichagePopupActionOnFace = true;
          this.action = this.constantes.ACTION_MASS_LAISSER_NE_PAS_LAISSER;
          break;
        case this.constantes.ACTION_MASS_GRATTER_NE_PAS_GRATTER:
          this.affichagePopupActionOnFace = true;
          this.action = this.constantes.ACTION_MASS_GRATTER_NE_PAS_GRATTER;
          break;
        default:
          break;
      }
    },
  },
  mounted() {
    this.initSelection();
  },
};
</script>
